import { ACTIVE_ALIGNMENT_COLOR } from "../../synteny-worker/settings.ts";
import type { TrackGroup } from "../../types.ts";

export const renderAlignment = (
  height: number,
  ctx: CanvasRenderingContext2D,
  trackGroup: TrackGroup,
  start: number,
  basePerPixel: number,
  scrollX: number,
) => {
  const width = 3;
  const startX = Math.floor((trackGroup.graphics.baseShift + start - 1) / basePerPixel - scrollX - width);
  ctx.save();
  ctx.fillStyle = ACTIVE_ALIGNMENT_COLOR;
  ctx.globalAlpha = 0.45;
  ctx.fillRect(startX, 0, width, height);
  ctx.restore();
};
